import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Sectiontitle from '../section-title';
import { useSiteSettings } from '../../siteSettings';
import { resolveMediaUrl } from '../../siteSettings';
import './style.css';

const formatDate = (value) => {
    if (!value) return '';
    const date = new Date(`${value}T00:00:00`);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
};

const Location = () => {
    const settings = useSiteSettings();
    const section = settings.eventSection;
    const [modal, setModal] = useState(false);
    const dateText = [formatDate(settings.weddingDate), settings.weddingTime].filter(Boolean).join(', de ');
    if (!section || !section.title) return null;
    const events = section.items || [];

    const mapAction = settings.mapEmbedLink ? (
        <Button className="btn" onClick={() => setModal(true)}>Voir le lieu</Button>
    ) : settings.googleMapLink ? (
        <a className="btn" href={settings.googleMapLink} target="_blank" rel="noopener noreferrer">Voir le lieu</a>
    ) : null;

    return (
        <div id="event" className="event-section section-padding">
            <Sectiontitle section={section.title} />
            <div className="container"><div className="row"><div className="col-12"><div className="tabs-site-button"><div className="event-tabs">
                <div className="col-md-12 col-12">
                    {events.map((event, index) => (
                        <div className="event-wrap" key={event.title}>
                            <div className="row">
                                {index % 2 === 0 && <div className="col-lg-5 col-md-12 col-12"><div className="event-img"><img src={resolveMediaUrl(event.image)} alt="" /></div></div>}
                                <div className={`col-lg-7 col-md-12 col-12 ${index % 2 ? 'order-lg-1' : ''}`}><div className={`event-text ${index % 2 ? 'event-text-2' : ''}`}>
                                    <h3>{event.title}</h3>
                                    <span>{dateText}</span>
                                    <p>{event.description}</p>
                                    {mapAction}
                                </div></div>
                                {index % 2 === 1 && <div className="col-lg-5 col-md-12 col-12 order-lg-2"><div className="event-img"><img src={resolveMediaUrl(event.image)} alt="" /></div></div>}
                            </div>
                        </div>
                    ))}
                </div>
            </div></div></div></div></div>
            {settings.mapEmbedLink && <Modal isOpen={modal} toggle={() => setModal(!modal)}>
                <ModalHeader toggle={() => setModal(!modal)}>Lieu de célébration</ModalHeader>
                <ModalBody><div className="location-map"><iframe title="Carte de la célébration" src={settings.mapEmbedLink} /></div></ModalBody>
            </Modal>}
        </div>
    );
};

export default Location;
